var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgGradientLayer = function SvgGradientLayer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 74 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.349 45.649c-11.217-8.572-22.642-17.58-33.878-26.471a2.703 2.703 0 0 0-3.362 0c-11.236 8.89-22.66 17.9-33.878 26.47-1.386 1.059-1.361 3.115.046 4.207C12.67 58.693 24.09 67.842 35.14 76.745c.97.783 2.332.783 3.303 0 11.05-8.903 22.469-18.052 33.861-26.89 1.407-1.092 1.431-3.148.046-4.206Z",
    fill: "url(#gradient-layer_svg__a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.376 36.72c-11.32-8.704-22.758-17.783-33.917-26.68a2.666 2.666 0 0 0-3.337 0C23.965 18.937 12.527 28.016 1.207 36.72a2.633 2.633 0 0 0 0 4.207c11.32 8.704 22.758 17.783 33.916 26.68.981.782 2.357.782 3.337 0 11.16-8.897 22.596-17.976 33.916-26.68a2.633 2.633 0 0 0 0-4.207Z",
    fill: "url(#gradient-layer_svg__b)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.703 58.824a2.699 2.699 0 0 0 .21.082l-.21-.082Zm-.593-.357c.062.049.126.095.19.137l.198.12a2.715 2.715 0 0 1-.198-.12l-.19-.137ZM13.918 41.794c1.415 1.103 2.83 2.209 4.246 3.317l4.247 3.333a2929.797 2929.797 0 0 0-4.247-3.332l-4.246-3.318Zm45.746 0a2597.99 2597.99 0 0 0-4.246 3.317l4.246-3.317ZM.82 31.605c-.95-1.116-.791-2.846.458-3.815C12.671 18.952 24.09 9.803 35.14.9a2.617 2.617 0 0 1 3.303 0c11.05 8.903 22.47 18.052 33.863 26.89 1.195.928 1.391 2.551.573 3.668a2.588 2.588 0 0 0 .45-1.994c-.102.408-.43.794-.991 1.071-8.606 4.037-17.275 8.25-25.937 12.484a21.832 21.832 0 0 1-19.217 0c-8.662-4.234-17.33-8.447-25.937-12.484-.562-.277-.89-.663-.991-1.071-.136.748.05 1.535.565 2.141Zm.266.27c.047.041.095.082.146.121 1.403 1.071 2.808 2.15 4.216 3.233l4.23 3.269c-2.824-2.189-5.641-4.36-8.446-6.502-.05-.039-.1-.08-.146-.121Zm-.149-.142Z",
    fill: "url(#gradient-layer_svg__c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.273 28.805a2.59 2.59 0 0 1-.978 2.533L68.08 34.57C58.225 42.16 48.249 50.03 38.417 57.81a2.701 2.701 0 0 1-3.36 0c-11.237-8.891-22.663-17.9-33.88-26.471A2.695 2.695 0 0 1 .65 30.8a2.588 2.588 0 0 1-.45-1.995c.103.408.43.795.992 1.072 8.606 4.037 17.275 8.25 25.936 12.484a21.832 21.832 0 0 0 19.218 0c8.662-4.234 17.33-8.447 25.937-12.484.562-.277.89-.664.991-1.072Z",
    fill: "url(#gradient-layer_svg__d)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-layer_svg__a",
    x1: 75.208,
    y1: 10.196,
    x2: -43.023,
    y2: 99.848,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-layer_svg__c",
    x1: 33.989,
    y1: 119.978,
    x2: 36.83,
    y2: 0.312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.934
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-layer_svg__d",
    x1: 39.419,
    y1: 56.137,
    x2: 31.584,
    y2: -2.623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "gradient-layer_svg__b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.04659 33.96057 -42.35886 .0581 36.79 38.824)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.162,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.768
  })))));
};

export default SvgGradientLayer;